import React from 'react';
import { Box, Card, CardContent, Chip, Typography, Button, CircularProgress } from '@mui/material';

const ACTION_LABELS = {
  create_customer: 'New Customer',
  create_customer_contact: 'New Contact',
  create_project: 'New Project',
  create_quote: 'New Quote',
  create_invoice: 'New Invoice',
  create_report: 'New Report',
};

export default function ActionConfirmationCard({ pendingAction, onConfirm, onCancel, loading, disabled }) {
  if (!pendingAction) return null;

  const actionLabel = ACTION_LABELS[pendingAction.actionType] || pendingAction.actionType;
  const displayFields = pendingAction.displayFields || [];

  return (
    <Card
      elevation={0}
      sx={{
        border: '1px solid #EEF2F6',
        borderRadius: 2,
        bgcolor: disabled ? '#F8FAFC' : '#FAFBFC',
        maxWidth: 420,
        mt: 1,
        opacity: disabled ? 0.6 : 1,
      }}
    >
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        {/* Header chip */}
        <Box sx={{ mb: 1.5 }}>
          <Chip
            label={actionLabel}
            size="small"
            sx={{
              bgcolor: '#EFF6FF',
              color: '#427898',
              fontWeight: 700,
              fontSize: 11,
              height: 22,
            }}
          />
        </Box>

        {/* Field rows */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, mb: disabled ? 0 : 2 }}>
          {displayFields.map((field, idx) => (
            <Box key={idx} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: 1 }}>
              <Typography
                sx={{
                  fontSize: 11,
                  color: '#94A3B8',
                  fontWeight: 600,
                  minWidth: 100,
                  pt: 0.1,
                  flexShrink: 0,
                }}
              >
                {field.label}
              </Typography>
              <Typography
                sx={{
                  fontSize: 13,
                  color: '#1E293B',
                  fontWeight: 500,
                  wordBreak: 'break-word',
                }}
              >
                {field.value != null && field.value !== '' ? field.value : '—'}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Footer buttons — hidden when disabled */}
        {!disabled && (
          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
            <Button
              variant="outlined"
              size="small"
              onClick={onCancel}
              disabled={loading}
              sx={{
                textTransform: 'none',
                fontSize: 12,
                color: '#64748B',
                borderColor: '#E2E8F0',
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={onConfirm}
              disabled={loading}
              sx={{
                textTransform: 'none',
                fontSize: 12,
                bgcolor: '#427898',
                '&:hover': { bgcolor: '#355f79' },
                minWidth: 80,
              }}
            >
              {loading ? (
                <CircularProgress size={14} sx={{ color: '#fff' }} />
              ) : (
                'Confirm'
              )}
            </Button>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
